/*
 * Copyright (c) 2025 by PROS, Inc.  All Rights Reserved.
 * This software is the confidential and proprietary information of
 * PROS, Inc. ("Confidential Information").
 * You may not disclose such Confidential Information, and may only
 * use such Confidential Information in accordance with the terms of
 * the license agreement you entered into with PROS.
 */
import { css } from 'lit';
export const button = css `
  button {
    display: flex;
    flex-direction: row;
    border: 1px solid #e0e0e0;
    background-color: #fff;
    border-radius: 4px;
    padding: 6px 10px;
    font-size: var(--pwc-font-size-small, 0.875rem);
    align-items: center;
    cursor: pointer;
    color: #000;
    margin-top: 10px;
  }

  button:hover {
    border: 1px solid #e9e9e9;
  }

  button svg {
    color: #444;
    width: 12px;
    height: 12px;
    margin-right: 5px;
  }

  button.blue {
    color: white;
    border: 1px solid #0f6eef;
    background-color: #0f6eef;
  }

  button.blue:hover {
    border: 1px solid #5899f5;
  }

  button:disabled {
    border: 1px solid #d0d0d0;
    background-color: #dedede;
    color: #a0a0a0;
    cursor: inherit;
  }

  button.blue:disabled:hover {
    border: 1px solid #d0d0d0;
  }
`;
//# sourceMappingURL=styles.js.map